import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Clock, CalendarClock, CheckCircle2 } from "lucide-react";

const AGENDA = [
  ["Offer audit", "8 min", "We pressure-test your One-Page Offer Doc: the name, the outcome, the price, and the anchor you'll use on calls."],
  ["Market fit check", "6 min", "Confirm your chosen niche is funded, painful, and reachable before you spend a weekend on it."],
  ["Launch plan", "8 min", "Map your first 20 outreach targets and lock the exact opener you'll send Sunday night."],
  ["Delivery and hiring", "5 min", "Line up the freelancer build so selling and building run in parallel, not back to back."],
  ["Open Q&A", "3 min", "Anything still standing between you and a launched offer this weekend."],
];

export default function BookCall() {
  const [calendlyUrl, setCalendlyUrl] = useState("");

  useEffect(() => {
    api.get("/config/calendly").then((r) => setCalendlyUrl(r.data?.url || "")).catch(() => {});
  }, []);

  return (
    <div data-testid="book-call-page">
      <div className="eyebrow" style={{ color: "#2038E6" }}>Book Your Launch Call</div>
      <h1 className="h-display" style={{ fontSize: "clamp(32px,5vw,48px)", marginTop: 8 }}>Your 1-on-1 Launch Call</h1>
      <p style={{ color: "var(--muted)", marginTop: 10, maxWidth: 620 }}>Thirty focused minutes to sharpen your offer and lock your launch plan before you start the weekend.</p>

      <div style={{ background: "#FFDF57", borderRadius: 12, padding: 16, marginTop: 18, display: "flex", gap: 10, alignItems: "center" }}>
        <CalendarClock size={20} />
        <span className="font-archivo" style={{ fontWeight: 800 }}>Limited spots each month. Book before you start the weekend plan.</span>
      </div>

      <div className="card-paper" style={{ padding: 24, marginTop: 20 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Clock size={18} color="#2038E6" />
          <h2 className="font-archivo" style={{ fontWeight: 900, textTransform: "uppercase", fontSize: 18 }}>30-minute call agenda</h2>
        </div>
        <div style={{ marginTop: 14 }} data-testid="call-agenda">
          {AGENDA.map(([title, mins, desc], i) => (
            <div key={i} style={{ display: "flex", gap: 14, padding: "14px 0", borderTop: i === 0 ? "none" : "1px solid var(--line)" }}>
              <CheckCircle2 size={18} color="#2038E6" style={{ flexShrink: 0, marginTop: 3 }} />
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: 12, alignItems: "baseline" }}>
                  <span className="font-archivo" style={{ fontWeight: 800, fontSize: 16 }}>{title}</span>
                  <span className="font-mono-plex" style={{ fontSize: 12, color: "var(--muted)", flexShrink: 0 }}>{mins}</span>
                </div>
                <p style={{ color: "var(--muted)", fontSize: 14, marginTop: 4 }}>{desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Scheduling widget slot */}
      <div data-testid="scheduling-slot" style={{ marginTop: 20, borderRadius: 14, overflow: "hidden", border: "1px solid var(--line)" }}>
        {calendlyUrl ? (
          <iframe title="scheduling" src={calendlyUrl} style={{ width: "100%", height: 640, border: 0 }} />
        ) : (
          <div style={{ minHeight: 300, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12, background: "#fff", textAlign: "center", padding: 28 }}>
            <div style={{ width: 40, height: 6, background: "#FFDF57" }} />
            <CalendarClock size={40} color="#2038E6" strokeWidth={1.5} />
            <span className="font-archivo" style={{ fontWeight: 800, fontSize: 20 }}>Booking opens soon</span>
            <span style={{ fontSize: 14, color: "var(--muted)", maxWidth: 420 }}>Scheduling for launch calls is opening shortly. Your spot is reserved with your membership. Keep working the training and asset vault in the meantime; this calendar goes live here first.</span>
          </div>
        )}
      </div>
    </div>
  );
}
